import axios from "axios";
import {
    db_url,
    url_org_structure,
    url_org_structure_branches,
    url_org_structure_filter,
    url_org_structure_parent,
} from "../url";

export default function DB_OrgStructure(token) {
    const url = '/dictionary/org_structures'
    const formData = new FormData;
    formData.append('token', token);

    const appendToken = (data) => {
        const fd = new FormData;
        for (const pair of data.entries()) {
            fd.append(pair[0], pair[1]);
        }
        fd.append('token', token);
        return fd
    }

    const getOrgStructures = () => {
        return axios.get(db_url + '/dictionary/org_structures/', {
            headers: {
                Authorization: token
            }
        })
    }

    const getOrgStructureParent = (data) => {
        return axios.post(url_org_structure_parent, appendToken(data))
    }

    const getOrgStructure = (org_structure_id) => {
        return axios.post(url_org_structure + org_structure_id, formData)
    }

    async function getOrgStructureFilter(org_structure) {
        const formData = new FormData
        formData.append('name', org_structure)

        return new Promise(resolve => {
            axios.post(url_org_structure_filter, appendToken(formData))
                .then(res => {
                    const data = res.data.map(user => (
                        {
                            label: user.name,
                            value: user.id
                        }
                    ))
                    resolve(data)
                })
        })
    }


    const createOrgStructure = (data) => {
        // return axios.post('http://127.0.0.1:3002/api_web/v1' + '/dictionary/org_structure/', appendToken(data))
        return axios.post(db_url + '/dictionary/org_structure/', appendToken(data))
    }

    const updateOrgStructure = (data) => {
        return axios.put(url_org_structure, appendToken(data))
    }


    const statusOrgStructure = (data) => {
        // return axios.post('http://127.0.0.1:3002/api_web/v1' + '/dictionary/org_structure/status', appendToken(data))
        return axios.post(db_url + '/dictionary/org_structure/status', appendToken(data))
    }

    const getBranchesForOrgStructure = (data) => {
        return axios.post(url_org_structure_branches, appendToken(data))
    }

    const getAccessCode = (id) => {
        // return axios.get('http://127.0.0.1:3002/api_web/v1' + url + '/access', {
        return axios.get(db_url + url + '/access', {
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }

    return {
        getOrgStructures,
        getOrgStructureParent,
        getOrgStructure,
        createOrgStructure,
        updateOrgStructure,
        statusOrgStructure,
        getBranchesForOrgStructure,
        getOrgStructureFilter,
        getAccessCode
    }
}
